// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1rA5I","head":"Table_head__2QlmI","col":"Table_col__30XiR"};